import { createSlice } from "@reduxjs/toolkit";

const initialOrdersListState = {
  purchaseOrders: [],
  purchaseOrdersTotalCount: 0,
  listLoading: false,
  actionsLoading: false,
  orderEntities: null,
  statusChanged: false,
  completed: false,
  message: {
    error: null,
    success: null,
  },
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const purchaseOrdersListSlice = createSlice({
  name: "purchase-receive",
  initialState: initialOrdersListState,
  reducers: {
    catchError: (state, action) => {
      let error =
        action.payload.error.response && action.payload.error.response.data ? action.payload.error.response.data.errors : action.payload.error.message;
      if (error.constructor.name === "Object") {
        let temp = [];
        for (let [k, v] of Object.entries(error)) {
          temp.push(`${k}->${v}`);
        }
        error = temp;
      }
      state.message.error = error;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    // findOrders
    ordersFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },

    //for PO invoice

    // change order status
    changeOrderStatus: (state, action) => {
      state.message.success = "Status Changed Successfully";
      state.error = null;
      state.statusChanged = true;
      state.actionsLoading = false;
      const { order } = action.payload;
      state.purchaseOrders = state.purchaseOrders.map((entity) => {
        if (order.id === entity.id) {
          entity = order;
        }
        return entity;
      });
    },
     // change order status
    closeOrderStatus: (state, action) => {
      state.message.success = "Status Changed Successfully";
      state.error = null;
      state.statusChanged = true;
      state.actionsLoading = false;
      const { order } = action.payload;
      state.purchaseOrders = state.purchaseOrders.map((entity) => {
        if (order.id === entity.id) {
          entity = order;
        }
        return entity;
      });
    },
    // Purchase order completely received
    receivedCompletely: (state, action) => {
      state.actionsLoading = false;
      const { order, message } = action.payload;
      state.message.success = message;
      state.purchaseOrders = state.purchaseOrders.map((entity) => {
        if (order.id === entity.id) {
          entity = order;
        }
        return entity;
      });
    },

    purchaseOrdersFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.error = null;
      state.actionsLoading = false;
      state.purchaseOrders = entities;
      state.purchaseOrdersTotalCount = totalCount;
      state.listLoading = false;
    },

    //order search started-----------
    // getOrders
    findOrderByNo: (state, action) => {
      const { entities } = action.payload;
      // state.listLoading = false;
      state.error = null;
      state.orderEntities = entities;
    },

    statusChanged: (state, action) => {
      state.statusChanged = action.payload.statusChanged;
      state.message.success = null;
    },
    responseMessageChanged: (state, action) => {
      state.message.success = null;
    },
    resetState: (state, action) => {
      state.purchaseOrders = null;
      state.complete = null;
    },
    //update message
    updateMessage: (state, action) => {
      const { type, message } = action.payload;
      switch (type) {
        case "error":
          state.message.error = message;
          break;
        case "success":
          state.message.success = message;
          break;
      }
    },
  },
});
